<script>
/* #ifdef H5 */
(function () {
	if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") { //判断程序运行环境是否是微信浏览器(微信内置的浏览器)
		handleFontSize();
	} else {
		if (document.addEventListener) {
			document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
		} else if (document.attachEvent) {
			document.attachEvent("WeixinJSBridgeReady", handleFontSize);
			document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
		}
	}

	function handleFontSize() {
		// 设置网页字体为默认大小
		WeixinJSBridge.invoke('setFontSizeCallback', {
			'fontSize': 0
		});
		// 重写设置网页字体大小的事件
		WeixinJSBridge.on('menu:setfont', function () {
			WeixinJSBridge.invoke('setFontSizeCallback', {
				'fontSize': 0
			});
		});
	}
})();
/* #endif */

export default {
	globalData: {
		is_flag: true //跳转开关

	},
	onLaunch: function () {
		// 非开发工具移除 console.log console.info
		if (process.env.NODE_ENV !== 'development') {
			console.log = () => { };
			console.info = () => { };
		}
		console.log('App Launch', process.env.NODE_ENV)
		const token = uni.getStorageSync('token')
		if (!token) {
			uni.reLaunch({
				url: "/pages/login/login",
			})
		}
	},
	onShow: function () {
		console.log('App Show')
	},
	onHide: function () {
		console.log('App Hide')
	}
}


</script>

<template>
  <router-view></router-view>

</template>

<style >
.flex {
		display: flex;
	}

.flex-between {
		display: flex;
		justify-content: space-between;
	}
.flex-between-items{
		display: flex;
		align-items: center;
		justify-content: space-between;
}
.flex-around-items{
		display: flex;
		align-items: center;
		justify-content: space-around;
}
.flex-items{
		display: flex;
	align-items: center;
	}
	 .van-toast--top{
  z-index: 20003 !important;
}
.bag-white{
	background: #fff;
}
.flex-wrap{
	flex-wrap: wrap;
}

/* #ifdef H5 */
body {
	/* IOS禁止微信调整字体大小 */
	-webkit-text-size-adjust: 100% !important;
	text-size-adjust: 100% !important;
	-moz-text-size-adjust: 100% !important;
}
/* #endif */	
</style>
